


class CookieHelper {
	setCookie =(cookieName, cookieValue, timeToExpire) => {
		var date = new Date((timeToExpire) * 1000);
		if(process.env.REACT_APP_DEV == 0) {
		  document.cookie = cookieName + " = " + cookieValue + "; path=/; domain=.paperchip.world; SameSite=None; Secure; "; //expires = " +date.toGMTString()+";";
		} else {
			// TODO: CHANge cookie for production!!!!
		//   document.cookie = cookieName + " = " + cookieValue + "; path=/; SameSite=None; Secure; "; //expires = " +date.toGMTString()+";";
		  document.cookie = cookieName + " = " + cookieValue + "; path=/; "; //expires = " +date.toGMTString()+";";
		  }
	}

	getCookie =(cName) => {
		const name = cName + "=";
		const cDecoded = decodeURIComponent(document.cookie); //to be careful
		const cArr = cDecoded .split('; ');
		let res;
		cArr.forEach(val => {
			if (val.indexOf(name) === 0) res = val.substring(name.length);
		})
		return res;
	}
	
	setTokenCookie=(data) => {
		var tokenData = {};
		tokenData.token = data.token;
		tokenData.token_valid_till = data.token_valid_till;
		tokenData.uuid = data.uuid
		//tokenData.userAgent = uuidv5(window.navigator.userAgent);
				
		this.setCookie("ppc_obj", JSON.stringify(tokenData), data.token_valid_till);			
	}

	getToken=(data) => {
		let rawCookie = this.getCookie("ppc_obj");
		let retVal = '';
		if(typeof rawCookie != 'undefined') {
			let tokenObj = JSON.parse(rawCookie);
			if (tokenObj && tokenObj.token) {
				retVal = tokenObj.token;
			}
		}
	}
	
}
export default new CookieHelper();